import DOMPurify from 'dompurify';

const EXTERNAL_HOSTS_EXCLUDE = [
	'cdc.gov',
	'localhost',
	'facebook.com',
	'twitter.com',
	'linkedin.com',
	'pinterest.com',
	'youtube.com',
	'youtube-nocookie.com',
	'plus.google.com',
	'instagram.com',
	'flickr.com',
	'tumblr.com',
	'cdc.sharepoint.com',
	'vaccines.gov',
	'vacunas.gov',
];
const EXTERNAL_HOSTS_EXCLUDE_VVV = ['localhost', 'vvvlink.wcms', 'vvvdev.wcms', 'vvv.wcms'];
const NEWTAB_HOSTS = [
	'facebook.com',
	'twitter.com',
	'linkedin.com',
	'pinterest.com',
	'youtube.com',
	'youtube-nocookie.com',
	'plus.google.com',
	'instagram.com',
	'flickr.com',
	'tumblr.com',
];
const FILE_EXT_ICONS = {
	pdf: 'pdf',
	ppt: 'ppt',
	pptx: 'ppt',
	ppsx: 'ppt',
	odt: 'word',
	doc: 'word',
	docx: 'word',
	png: 'image',
	jpg: 'image',
	jpeg: 'image',
	gif: 'image',
	bmp: 'image',
	tiff: 'image',
	xls: 'excel',
	xlsx: 'excel',
	csv: 'excel',
	mp3: 'media',
	mp4: 'media',
	wmv: 'media',
	webm: 'media',
	wav: 'media',
	ogg: 'media',
	wma: 'media',
	mov: 'media',
	rm: 'media',
	mpeg: 'media',
	ram: 'media',
	ogv: 'media',
	avi: 'media',
	qt: 'media',
	mpg: 'media',
	txt: 'txt',
	rtf: 'txt',
	zip: 'zip',
	epub: 'epub',
	sas: 'sas',
	dta: 'stats',
	sps: 'stats',
	sav: 'stats',
};

const FILE_EXT_ICONS_TP5 = 'csv|doc|docx|gif|jpeg|jpg|json|m4a|mov|mp3|pdf|png|png|ppt|pptx|qt|ram|rm|txt|wav|webp|xls|xlsx|zip'.split('|');

const FILE_ICON_DESCRIPTION = {
	epub: 'ePub',
	excel: 'XLS',
	image: 'Image',
	media: 'Media',
	pdf: 'PDF',
	ppt: 'PPT',
	sas: 'SAS',
	stats: 'Stats',
	txt: 'TXT',
	word: 'DOC',
	zip: 'Zip',
};

const LANGS = {
	en: { name: 'English', intl: 'English' },
	es: { name: 'Spanish', intl: 'Español' },
	zh: { name: 'Chinese', intl: '中文' },
	vi: { name: 'Vietnamese', intl: 'Tiếng Việt' },
	ko: { name: 'Korean', intl: '한국어' },
	tl: { name: 'Tagalog', intl: 'Tagalog' },
	ru: { name: 'Russian', intl: 'Русский' },
	ar: { name: 'Arabic', intl: 'العربية' },
	ht: { name: 'Creole', intl: 'Kreyòl' },
	fr: { name: 'French', intl: 'Français' },
	pl: { name: 'Polish', intl: 'Polski' },
	pt: { name: 'Portuguese', intl: 'Português' },
	it: { name: 'Italian', intl: 'Italiano' },
	de: { name: 'German', intl: 'Deutsch' },
	ja: { name: 'Japanese', intl: '日本語' },
	fa: { name: 'Farsi', intl: 'فارسی' },
	ms: { name: 'Malay', intl: 'Bahasa Melayu' },
	hi: { name: 'Hindi', intl: 'हिन्दी' },
	th: { name: 'Thai', intl: 'ภาษาไทย' },
	ase: { name: 'American Sign Language (ASL)', intl: 'American Sign Language (ASL)' },
	am: { name: 'Amharic', intl: 'ኣማርኛ' },
	my: { name: 'Burmese', intl: 'ဗမာစကား' },
	prs: { name: 'Dari', intl: 'درى' },
	ne: { name: 'Nepali', intl: 'नेपाली' },
	ps: { name: 'Pashto', intl: 'پښتو' },
	so: { name: 'Somali', intl: 'af Soomaali' },
	sw: { name: 'Swahili', intl: 'Kiswahili' },
	ti: { name: 'Tigrinya', intl: 'ትግርኛ' },
	uk: { name: 'Ukrainian', intl: 'Українська' },
	kar: { name: 'Karen', intl: 'Karen' },
	rw: { name: 'Kinyarwanda', intl: 'Ikinyarwanda' },
	kun: { name: 'Kunama', intl: 'Kunama' },
	om: { name: 'Oromo', intl: 'Afaan Oromo' },
	chk: { name: 'Chuukese', intl: 'Chuukese' },
	mh: { name: 'Marshallese', intl: 'Marshallese' },
	to: { name: 'Tongan', intl: 'Tongan' },
	he: { name: 'Hebrew', intl: 'עִבְרִית' },
	yi: { name: 'Yiddish', intl: 'ײִדיש' },
	hmn: { name: 'Hmong', intl: 'Hmong' },
	sr: { name: 'Serbian', intl: 'српски језик' },
	ku: { name: 'Kurdish', intl: 'کوردی' },
	urd: { name: 'Urdu', intl: 'اُردُو' },
	dz: { name: 'Dzongkha', intl: 'Dzongkha' },
	rn: { name: 'Rundi', intl: 'Rundi' },
	ilo: { name: 'Ilocano', intl: 'Ilocano' },
	haw: { name: 'Hawaiian', intl: 'ʻŌlelo Hawaiʻi' },
	'zh-hans': 'Simplified Chinese',
	'zh-hant': 'Traditional Chinese',
	'es-pr': 'Spanish (Puerto Rico)',
	'pt-br': 'Brazilian Portuguese',
	bs: 'Bosnian',
	ab: 'Abkhazian',
	aa: 'Afar',
	af: 'Afrikaans',
	ak: 'Akan',
	sq: 'Albanian',
	an: 'Aragonese',
	hy: 'Armenian',
	as: 'Assemese',
	av: 'Avaric',
	ae: 'Avestan',
	ay: 'Aymara',
	az: 'Azerbaijani',
	bm: 'Bambara',
	ba: 'Bashkir',
	eu: 'Basque',
	be: 'Belarusian',
	bn: 'Bengali',
	bi: 'Bislama',
	br: 'Breton',
	bg: 'Bulgarian',
	ca: 'Catalan',
	ch: 'Chamorro',
	ce: 'Cechen',
	ny: 'Chichewa',
	cu: 'Church Slavonic',
	cv: 'Chuvash',
	kw: 'Cornish',
	co: 'Corsican',
	cr: 'Cree',
	hr: 'Croatian',
	cs: 'Czech',
	da: 'Danish',
	dv: 'Divehi',
	nl: 'Dutch',
	eo: 'Esperanto',
	et: 'Estonian',
	ee: 'Ewe',
	fo: 'Faroese',
	fj: 'Fijian',
	fi: 'Finnish',
	fy: 'Western Frisian',
	ff: 'Fulah',
	gd: 'Gaelic',
	gl: 'Galician',
	lg: 'Luganda',
	ka: 'Georgian',
	el: 'Greek',
	kl: 'Kalaallisut',
	gn: 'Guarani',
	gu: 'Gujarati',
	ha: 'Hausa',
	hz: 'Herero',
	ho: 'Hiri Motu',
	hu: 'Hungarian',
	is: 'Icelandic',
	io: 'Ido',
	ig: 'Igbo',
	id: 'Indonesian',
	ia: 'Interlingua',
	ie: 'Interlingue',
	iu: 'Inukitut',
	ik: 'Inupiaq',
	ga: 'Irish',
	jv: 'Javanese',
	kn: 'Kannada',
	kr: 'Kanuri',
	ks: 'Kashmiri',
	kk: 'Kazakh',
	km: 'Central Khmer',
	quc: "K'iche'",
	ki: 'Kikuyu',
	ky: 'Kirghiz',
	kv: 'Komi',
	kg: 'Kongo',
	kj: 'Kuanyama',
	lo: 'Lao',
	la: 'Latin',
	lv: 'Latvian',
	li: 'Limburgan',
	ln: 'Lingala',
	lt: 'Lithuanian',
	lu: 'Luba Katanga',
	lb: 'Luxembourgish',
	mk: 'Macedonian',
	mg: 'Malagasy',
	ml: 'Malayalam',
	mt: 'Maltese',
	gv: 'Manx',
	mi: 'Maori',
	mr: 'Marathi',
	mn: 'Mongolian',
	nah: 'Nahuatl',
	na: 'Nauru',
	nv: 'Navajo',
	nd: 'North Ndebele',
	nr: 'South Nedebele',
	ng: 'Ndonga',
	no: 'Norwegian',
	nb: 'Norwegian Bokmal',
	nn: 'Norwegian Nynorsk',
	ii: 'Sichuan Yi',
	oc: 'Occitian',
	oj: 'Ojibwa',
	or: 'Oriya',
	os: 'Ossetian',
	pi: 'Pali',
	pa: 'Punjabi',
	qu: 'Quechua',
	ro: 'Romanian',
	rm: 'Romansh',
	se: 'Northern Sami',
	sm: 'Samoan',
	sg: 'Sango',
	sa: 'Sanskrit',
	sc: 'Sardinian',
	sn: 'Shona',
	sd: 'Sindhi',
	si: 'Sinhala',
	sk: 'Slovak',
	sl: 'Slovenian',
	st: 'Southern Southo',
	su: 'Sundanese',
	ss: 'Swati',
	sv: 'Swedish',
	ty: 'Tahitian',
	tg: 'Tajik',
	ta: 'Tamil',
	tt: 'Tatar',
	te: 'Telugu',
	bo: 'Tibetan',
	ts: 'Tsonga',
	tn: 'Tswana',
	tr: 'Turkish',
	tk: 'Turkmen',
	tw: 'Twi',
	ug: 'Uighur',
	uz: 'Uzbek',
	ve: 'Venda',
	vo: 'Volapuk',
	wa: 'Walloon',
	cy: 'Welsh',
	wo: 'Wolof',
	xh: 'Xhosa',
	yo: 'Yoruba',
	za: 'Zhuang',
	zu: 'Zulu',
	'__': 'Other Language',
};

const DIACRITICS = [
	{
		base: 'A',
		letters:
			/[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g,
	},
	{ base: 'AA', letters: /[\uA732]/g },
	{ base: 'AE', letters: /[\u00C6\u01FC\u01E2]/g },
	{ base: 'AO', letters: /[\uA734]/g },
	{ base: 'AU', letters: /[\uA736]/g },
	{ base: 'AV', letters: /[\uA738\uA73A]/g },
	{ base: 'AY', letters: /[\uA73C]/g },
	{ base: 'B', letters: /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g },
	{ base: 'C', letters: /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g },
	{ base: 'D', letters: /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g },
	{ base: 'DZ', letters: /[\u01F1\u01C4]/g },
	{ base: 'Dz', letters: /[\u01F2\u01C5]/g },
	{
		base: 'E',
		letters:
			/[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g,
	},
	{ base: 'F', letters: /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g },
	{
		base: 'G',
		letters: /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g,
	},
	{ base: 'H', letters: /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g },
	{
		base: 'I',
		letters:
			/[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g,
	},
	{ base: 'J', letters: /[\u004A\u24BF\uFF2A\u0134\u0248]/g },
	{ base: 'K', letters: /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g },
	{
		base: 'L',
		letters:
			/[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g,
	},
	{ base: 'LJ', letters: /[\u01C7]/g },
	{ base: 'Lj', letters: /[\u01C8]/g },
	{ base: 'M', letters: /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g },
	{
		base: 'N',
		letters: /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g,
	},
	{ base: 'NJ', letters: /[\u01CA]/g },
	{ base: 'Nj', letters: /[\u01CB]/g },
	{
		base: 'O',
		letters:
			/[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g,
	},
	{ base: 'OI', letters: /[\u01A2]/g },
	{ base: 'OO', letters: /[\uA74E]/g },
	{ base: 'OU', letters: /[\u0222]/g },
	{ base: 'P', letters: /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g },
	{ base: 'Q', letters: /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g },
	{
		base: 'R',
		letters:
			/[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g,
	},
	{
		base: 'S',
		letters:
			/[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g,
	},
	{
		base: 'T',
		letters: /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g,
	},
	{ base: 'TZ', letters: /[\uA728]/g },
	{
		base: 'U',
		letters:
			/[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g,
	},
	{ base: 'V', letters: /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g },
	{ base: 'VY', letters: /[\uA760]/g },
	{ base: 'W', letters: /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g },
	{ base: 'X', letters: /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g },
	{
		base: 'Y',
		letters: /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g,
	},
	{ base: 'Z', letters: /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g },
	{
		base: 'a',
		letters:
			/[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g,
	},
	{ base: 'aa', letters: /[\uA733]/g },
	{ base: 'ae', letters: /[\u00E6\u01FD\u01E3]/g },
	{ base: 'ao', letters: /[\uA735]/g },
	{ base: 'au', letters: /[\uA737]/g },
	{ base: 'av', letters: /[\uA739\uA73B]/g },
	{ base: 'ay', letters: /[\uA73D]/g },
	{ base: 'b', letters: /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g },
	{ base: 'c', letters: /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g },
	{ base: 'd', letters: /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g },
	{ base: 'dz', letters: /[\u01F3\u01C6]/g },
	{
		base: 'e',
		letters:
			/[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g,
	},
	{ base: 'f', letters: /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g },
	{
		base: 'g',
		letters: /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g,
	},
	{
		base: 'h',
		letters: /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g,
	},
	{ base: 'hv', letters: /[\u0195]/g },
	{
		base: 'i',
		letters:
			/[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g,
	},
	{ base: 'j', letters: /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g },
	{ base: 'k', letters: /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g },
	{
		base: 'l',
		letters:
			/[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g,
	},
	{ base: 'lj', letters: /[\u01C9]/g },
	{ base: 'm', letters: /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g },
	{
		base: 'n',
		letters:
			/[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g,
	},
	{ base: 'nj', letters: /[\u01CC]/g },
	{
		base: 'o',
		letters:
			/[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g,
	},
	{ base: 'oi', letters: /[\u01A3]/g },
	{ base: 'ou', letters: /[\u0223]/g },
	{ base: 'oo', letters: /[\uA74F]/g },
	{ base: 'p', letters: /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g },
	{ base: 'q', letters: /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g },
	{
		base: 'r',
		letters:
			/[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g,
	},
	{
		base: 's',
		letters:
			/[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g,
	},
	{
		base: 't',
		letters: /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g,
	},
	{ base: 'tz', letters: /[\uA729]/g },
	{
		base: 'u',
		letters:
			/[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g,
	},
	{ base: 'v', letters: /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g },
	{ base: 'vy', letters: /[\uA761]/g },
	{ base: 'w', letters: /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g },
	{ base: 'x', letters: /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g },
	{
		base: 'y',
		letters: /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g,
	},
	{ base: 'z', letters: /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g },
];

const $ = window.jQuery || window.$;

const utils = {
	// validator for date keyboard input
	checkDate: (input) => {
		if ('' === input) {
			return '';
		} else if (10 === input.length || 9 === input.length || 8 === input.length) {
			if (2 === input.match(/[/]/g).length) {
				var val = input.replace(/[/]/g, '');
				if (/^\d+$/.test(val)) {
					return input;
				}
			}
		} else {
			return false;
		}
	},

	cleanTerm: (term) => {
		return utils.cleanString(String(term).replace(/(["|;&$%#<>()+\?\~\*])/g, '\\$1'));
	},

	isEmpty: (val) => {
		if ('object' === typeof val && !Array.isArray(val)) {
			return JSON.stringify(val) === JSON.stringify({});
		}
		return '' === val || undefined === val || null === val;
	},

	isObject: (item) => {
		return item && 'object' === typeof item && !Array.isArray(item);
	},

	mergeDeep: (target, source) => {
		if (!source) {
			return target;
		}
		if (utils.isObject(target) && utils.isObject(source)) {
			for (const key in source) {
				if (utils.isObject(source[key])) {
					if (!target[key]) {
						Object.assign(target, { [key]: {} });
					}
					utils.mergeDeep(target[key], source[key]);
				} else {
					Object.assign(target, { [key]: source[key] });
				}
			}
		}
		return target;
	},

	/**
	 * Get a boolean from a value
	 * @param {any} value Value to evaluate as boolean
	 * @returns boolean
	 */
	toBoolean: (value) => {
		let bool = !!value;
		if ('string' === typeof value) {
			value = utils.cleanString(value).toLowerCase();
			bool = 'true' === value;
		}
		return bool;
	},

	/**
	 * Get a boolean from given boolean or string, with default state
	 * @param {any}     value Value to evaluate as boolean
	 * @param {boolean} default what the default return should be, true or false;
	 * @returns boolean
	 */
	toggleSwitch: (value, defaultValue) => {
		let bool = !!defaultValue;
		if ('string' === typeof value && value) {
			let string = value.toLowerCase().trim();
			switch (string) {
				case 'n':
				case 'no':
				case 'false':
				case 'off':
					bool = false;
					break;
				case 'y':
				case 'yes':
				case 'true':
				case 'on':
					bool = false;
					break;
			}
		}
		if ('boolean' === typeof value) {
			bool = value;
		}
		return bool;
	},

	/**
	 * Given an object and a template object to follow, ensures
	 * all properties of object follow format of template object
	 * @param {object} object
	 * @param {object} template
	 * @returns {object}
	 */
	templateObject: (object, template) => {
		object = Object.assign({}, object);
		for (let field in template) {
			if (!template.hasOwnProperty(field)) {
				continue;
			}
			let objectValue = object[field];
			let templateValue = template[field];
			let fieldType = typeof templateValue;
			let newValue = objectValue;
			if (Array.isArray(templateValue)) {
				fieldType = 'array';
			}

			// if template field missing, assign template value
			if (!object.hasOwnProperty(field)) {
				// don't carry over template arrays
				if ('array' === fieldType) {
					newValue = [];
				} else {
					newValue = templateValue;
				}
			} else if (fieldType !== typeof objectValue) {
				// if object value is of different type than template, cast it
				switch (fieldType) {
					case 'string':
						newValue = utils.cleanString(objectValue);
						break;
					case 'object':
						newValue = Object.assign({}, objectValue);
						break;
					case 'array':
						newValue = utils.toArray(objectValue);
						break;
					case 'boolean':
						newValue = Boolean(objectValue);
						break;
					case 'number':
						newValue = utils.toNumber(objectValue);
						if (isNaN(newValue)) {
							newValue = templateValue;
						}
						break;
				}
			}
			// finally template objects and arrays of objects
			if ('object' === fieldType) {
				newValue = utils.templateObject(newValue, templateValue);
			}
			if ('array' === fieldType && templateValue.length) {
				let firstTemplateValue = templateValue[0];
				newValue = utils.templateArray(newValue, firstTemplateValue);
			}
			object[field] = newValue;
		}
		return object;
	},

	/**
	 * Given an array and a template variable to follow, ensures
	 * each element of the array follows format of template variable
	 * @param {array} array
	 * @param {object} template
	 */
	templateArray: (array, template) => {
		let resultArray = [];
		let templateType = Array.isArray(template) ? 'array' : typeof template;
		array = utils.toArray(array);
		array.forEach((arrayItem) => {
			switch (templateType) {
				case 'object':
					if (!utils.isObject(arrayItem)) {
						return;
					}
					arrayItem = utils.templateObject(arrayItem, template);
					break;
				case 'array':
					arrayItem = utils.toArray(arrayItem);
					break;
				case 'string':
					arrayItem = utils.cleanString(arrayItem);
					break;
				case 'boolean':
					arrayItem = Boolean(arrayItem);
					break;
				case 'number':
					arrayItem = utils.toNumber(arrayItem);
					if (isNaN(arrayItem)) {
						return;
					}
					break;
			}
			resultArray.push(arrayItem);
		});
		return resultArray;
	},

	// Utilities
	stripTags: (input, allowed) => {
		let stripped = '';
		allowed = (
			String(allowed || '')
				.toLowerCase()
				.match(/<[a-z][a-z0-9]*>/g) || []
		).join(''); // making sure the allowed arg is a string containing only tags in lowercase (<a><b><c>)
		var tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi,
			commentsAndPhpTags = /<!--[\s\S]*?-->|<\?(?:php)?[\s\S]*?\?>/gi,
			brokenTags = /(<\w+(?:\s+\w+=\"[^"]+\")*)(?=[^>]+(?:<|$))/g;
		stripped = input
			.replace(commentsAndPhpTags, '')
			.replace(brokenTags, '')
			.replace(tags, function ($0, $1) {
				return -1 < allowed.indexOf('<' + $1.toLowerCase() + '>') ? $0 : '';
			});
		stripped.replace('&nbsp;', ' ');
		stripped.replace(/\&[rls]*quo/, "'");
		return stripped;
	},

	titleCase: (string) => {
		return String(string)
			.toLowerCase()
			.split(' ')
			.map(function (word) {
				return utils.ucFirst(word);
			})
			.join(' ');
	},

	ucFirst: (string) => {
		string = String(string);
		return string.charAt(0).toUpperCase() + string.slice(1);
	},

	lcFirst: (string) => {
		string = String(string);
		return string.charAt(0).toLowerCase() + string.slice(1);
	},

	// convert strings from camelCase variables to display values, e.g. myKey = "My Key"
	camelToPlain: (string) => {
		string = String(string);
		return utils.titleCase(string.replace(/([A-Z])/g, ' $1').replace('_', ' '));
	},

	// convert strings from "display" (human readable English) to camelCase string/var, e.g. "My Key" = myKey
	plainToCamel: (string) => {
		string = String(string);
		return utils.lcFirst(string.replace(/\s+/g, ''));
	},


	trailingSlash: (string) => {
		return utils.cleanString(string).replace(/([^\/])$/, '$1/');
	},

	unTrailingSlash: (string) => {
		return utils.cleanString(string).replace(/\/$/, '');
	},

	escapeString: (string, forAttribute) => {
		var ESC_MAP = {
			'&': '&amp;',
			'<': '&lt;',
			'>': '&gt;',
			'"': '&quot;',
			"'": '&#39;',
		};
		return String(string).replace(forAttribute ? /[&<>'"]/g : /[&<>]/g, function (c) {
			return ESC_MAP[c];
		});
	},

	unique: (array) => {
		array = array.filter(function (el) {
			return Boolean(el);
		});
		return array.filter(function (el, index, arr) {
			return index === arr.indexOf(el);
		});
	},

	arrayDiff: (a, b) => {
		if (!Array.isArray(a)) {
			return [];
		}
		if (!Array.isArray(b)) {
			b = [b];
		}
		var c = a.slice();
		b.forEach((term, i) => {
			var index = c.indexOf(term);
			if (-1 < index) {
				c.splice(index, 1);
			}
		});
		return c;
	},

	arrayFirst: (value) => {
		if (value === undefined || null === value) {
			return '';
		}
		value = utils.toArray(value);
		return value.length ? value[0] : '';
	},

	pad: (num, size, padding) => {
		padding = padding || '0';
		var s = String(num);
		size = size || 2;
		while (s.length < size) {
			s = padding + s;
		}
		return s;
	},

	/**
	 * Given a term, return an array of cleaned terms
	 * @param term
	 * @returns array
	 */
	getWords: (term) => {
		if (undefined === term || null === term) {
			return [];
		}
		var words = utils
			.cleanTerm(term)
			.trim()
			.split(/[\s,]+/);
		var result = [];
		words.forEach(function (word) {
			if ('&' === word) {
				word = 'and';
			}
			if (word) {
				result.push(word);
			}
		});
		return utils.unique(result);
	},

	getParam: (name, defaultValue) => {
		defaultValue = 'undefined' === typeof defaultValue ? null : defaultValue;
		name = name.replace(/[\[\]]/g, '\\$&');
		var url = String((window && window.location && window.location.href) || '');
		if (!url) {
			return defaultValue;
		}
		var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
			results = regex.exec(url);
		if (!results) {
			return defaultValue;
		}

		if (!results[2]) {
			return '';
		}
		return decodeURIComponent(results[2].replace(/\+/g, ' ')).replace(/[<>]/g, '');
	},

	getParamSwitch: (name, defaultValue) => {
		var param = utils.getParam(name);
		var value = false;
		if ('string' !== typeof param) {
			return Boolean(defaultValue);
		}
		if ('' === param) {
			return true;
		}
		param = String(param).trim().toLowerCase();
		if (param.match(/^\d+$/)) {
			value = Boolean(parseInt(param, 10));
		} else if (param.match(/^(n|no|f|false|off)$/)) {
			value = false;
		} else {
			value = true;
		}
		return value;
	},

	maybeJoin: (value, glue) => {
		if (Array.isArray(value)) {
			return value.join(glue).trim();
		}
		return String(value).trim();
	},

	toPiped: (array) => {
		array = utils.toArray(array);
		return array.join('|');
	},

	arrayToQuery: (array) => {
		let results = [];
		array = utils.toArray(array);
		if (!array.length) {
			return '';
		}
		array.forEach((item) => {
			results.push('"' + utils.cleanTerm(item) + '"');
		});
		return results.join(',');
	},

	// These are largely to get around IE11 compatibility
	objectKeys: (object) => {
		var keys = [];
		if ('object' === typeof object) {
			for (let key in object) {
				if (object.hasOwnProperty(key) && object[key]) {
					keys.push(key);
				}
			}
		}
		return keys;
	},

	// These are largely to get around IE11 compatibility
	objectValues: (object) => {
		var values = [];
		if ('object' === typeof object) {
			for (let key in object) {
				if (object.hasOwnProperty(key) && object[key]) {
					values.push(object[key]);
				}
			}
		}
		return values;
	},

	objectToArray: (object) => {
		let newArray = [];
		for (const itemKey in object) {
			let newItem = object[itemKey];
			newItem.identifier = itemKey;
			newArray.push(newItem);
		}

		return newArray;
	},

	cleanString: (string) => {
		if (Array.isArray(string)) {
			if (string.length) {
				string = string[0];
			} else {
				string = '';
			}
		}
		return String(string)
			.replace(/[\n\r\s]+/g, ' ')
			.trim();
	},

	cleanLabel: (string) => {
		let label = utils.stripTags(utils.cleanString(string));
		label = label.replace('&amp;', '&');
		return label;
	},

	truncateString: (string, length = 230, suffix = '&hellip;') => {
		let result = String(string)
			.trim()
			.replace(/[\n\r\s]+/g, ' ');
		let regex = new RegExp('^(.{' + parseInt(length, 10) + '}[\\S]*)');
		let matches = String(result).match(regex);
		if (matches && matches.length) {
			result = matches.shift();
			if (result && !result.match(/[.?!]$/)) {
				result += suffix;
			}
		}
		return result;
	},

	cleanHTML: (html) => {
		return DOMPurify.sanitize(utils.cleanString(html));
	},

	cleanDiacritics: (string) => {
		string = utils.cleanString(string);
		DIACRITICS.forEach((diacritics) => {
			string = string.replace(diacritics.letters, diacritics.base);
		});
		return string;
	},

	toArray: (value) => {
		if (!Array.isArray(value)) {
			if (undefined === value || null === value) {
				return [];
			}
			return [value];
		}
		return value;
	},


	toNumber: (value) => {
		if ('number' === typeof value) {
			return value;
		}
		return parseInt(utils.cleanString(value).replace(/[^\d\.]+/g, '') || 0);
	},

	// Builds a prop url given parts, no extra or missing slashes
	buildPath: (...args) => {
		var path = '';
		for (let key in args) {
			let part = String(args[key]).trim();
			if (!part) {
				continue;
			}
			if (path.match(/\/$/) && part.match(/^\//)) {
				part = part.replace(/^\//, '');
			}
			if (path && !path.match(/\/$/) && !part.match(/^\//)) {
				part = '/' + part;
			}
			path += part;
		}
		return path;
	},

	buildQueryParams: (params) => {
		let parts = [];
		for (let key in params) {
			if (params.hasOwnProperty(key)) {
				let value = params[key];
				if (Array.isArray(value) && value.length) {
					parts.push(key + '=' + utils.toPiped(value.map((item) => encodeURIComponent(item))));
					continue;
				}
				value = utils.cleanTerm(value);
				if (value) {
					parts.push(key + '=' + encodeURIComponent(value));
				}
			}
		}
		return '?' + parts.join('&');
	},

	intVal: (number) => {
		return parseInt(String(number).replace(/\D+/g, ''));
	},

	formatDate: (date) => {
		try {
			let d = new Date(utils.cleanString(date));
			if (isNaN(d.getSeconds())) {
				return '';
			}
			return new Intl.DateTimeFormat('en', { dateStyle: 'medium' }).format(d);
		} catch (error) {
			return '';
		}
	},

	unTrailingSlashit: (string) => {
		return utils.cleanString(string).replace(/\/$/, '');
	},

	unLeadingSlashit: (string) => {
		return utils.cleanString(string).replace(/^\//, '');
	},

	toDate: (date) => {
		let d = new Date(utils.cleanString(date));
		if (isNaN(d.getSeconds())) {
			return null;
		}
		return d;
	},

	escapeRegExp: (string) => {
		return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
	},

	randomNumber: (upperLimit, lowerLimit = 0) => {
		if (Number.isNaN(upperLimit) || Number.isNaN(lowerLimit)) {
			return 0;
		}
		lowerLimit = Math.ceil(Number(lowerLimit));
		upperLimit = Math.floor(Number(upperLimit));
		return Math.floor(Math.random() * (upperLimit - lowerLimit) + lowerLimit);
	},

	parseUrl: (targetURL) => {
		var parser = document.createElement('a'),
			searchObject = {},
			queries,
			split,
			i;
		// Let the browser do the work
		parser.href = utils.cleanUrl(targetURL || location.href, '');
		// Convert query string to object
		queries = parser.search.replace(/^\?/, '').split('&');
		for (i = 0; i < queries.length; i++) {
			split = queries[i].split('=');
			searchObject[split[0]] = 2 <= split.length ? split[1] : '';
		}
		// IE fix for pathname - misses leading slash
		let pathname = String(parser.pathname);
		if ('/' !== pathname.charAt(0)) {
			pathname = '/' + pathname;
		}
		let parts = pathname.split('/');
		let filename = parts.pop();
		parts = filename.split('.');
		let extension = parts.length ? parts.pop() : '';

		return {
			protocol: parser.protocol,
			host: parser.host,
			hostname: parser.hostname,
			port: parser.port,
			pathname,
			search: parser.search,
			searchObject: searchObject,
			params: searchObject,
			hash: parser.hash,
			filename,
			extension,
		};
	},

	cleanUrl: (targetURL, blankValue) => {
		blankValue = undefined === blankValue ? 'about:blank' : blankValue;
		var urlScheme, urlSchemeParseResults, sanitizedUrl, decodedUrl;
		if (!targetURL) {
			return blankValue;
		}
		sanitizedUrl = String(targetURL)
			.replace(/[^\x20-\x7E]/gim, '')
			.replace(/[^-A-Za-z0-9+&@#/%?=~_|!:,.;\(\)]+/g, '')
			.trim();
		try {
			decodedUrl = decodeURI(sanitizedUrl);
		} catch (error) {
			// malformed URI
			return blankValue;
		}
		if (/<script/im.test(decodedUrl)) {
			return blankValue;
		}
		urlSchemeParseResults = sanitizedUrl.match(/^([^:]+):/gm);
		if (!urlSchemeParseResults) {
			return sanitizedUrl;
		}
		urlScheme = urlSchemeParseResults[0];
		if (/^(%20|\s)*(javascript|data)/im.test(urlScheme)) {
			return blankValue;
		}
		return sanitizedUrl;
	},

	/**
	 * accept any site id or topical site id, and return a WCMS Site ID as a string
	 * if not found, returns an empty string
	 *
	 * @param {any} siteId
	 * @returns string
	 */
	getWCMSSiteId: (siteId) => {
		let wcmsSiteId = utils.cleanString(siteId).replace(/[-_].*/, '');
		wcmsSiteId = utils.toNumber(wcmsSiteId);
		return String(wcmsSiteId ? wcmsSiteId : '');
	},

	getUrlTld: (url) => {
		let tld = '';
		let host = utils.parseUrl(url).hostname;
		if (host) {
			tld = host.split('.').slice(-2).join('.');
		}
		return tld;
	},

	// test if url is external
	urlIsExternal: (url) => {
		let currentTld = utils.getUrlTld(location.href).toLowerCase();
		let exclusions = [].concat(EXTERNAL_HOSTS_EXCLUDE, currentTld);
		if (-1 < EXTERNAL_HOSTS_EXCLUDE_VVV.indexOf(currentTld)) {
			exclusions = exclusions.concat(EXTERNAL_HOSTS_EXCLUDE_VVV);
		}
		let tld = utils.getUrlTld(url).toLowerCase();
		return -1 === exclusions.indexOf(tld);
	},

	urlIsNewTab: (url) => {
		let tld = utils.getUrlTld(url).toLowerCase();
		return -1 < NEWTAB_HOSTS.indexOf(tld);
	},

	getIconForUrl: (url) => {
		let ext = String(utils.parseUrl(url).extension || '').toLowerCase();
		let icon = FILE_EXT_ICONS[ext] || '';
		return icon;
	},

	getTP5IconForUrl: (url) => {
		let ext = String(utils.parseUrl(url).extension || '').toLowerCase();
		let icon = FILE_EXT_ICONS_TP5.includes(ext) ? ext : '';
		return icon;
	},

	isFileUrl: (url) => {
		return !!utils.getIconForUrl(url);
	},

	// given a url, return a short link description
	getFileDescription: (url) => {
		let icon = utils.getIconForUrl(url);
		let description = FILE_ICON_DESCRIPTION[icon] || '';
		return description;
	},

	pluralize: (count, plural, singular) => {
		plural = plural || '';
		singular = singular || '';
		return 1 === count ? singular : plural;
	},

	/**
	 * Get language name by lang code
	 * @param {string} langCode       Language code
	 * @param {boolean} international Get the language name in its language
	 * @returns string
	 */
	getLanguage: (langCode, international) => {
		langCode = utils.cleanString(langCode).replace(/^.*-/, '');
		let lang = LANGS[langCode] || null;
		if (lang) {
			if ('string' === typeof lang) {
				lang = {
					intl: lang,
					name: lang,
				};
			}
			return international ? lang.intl : lang.name;
		}
		return '';
	},

	getLanguages: (international) => {
		const langs = {};
		for (let l in LANGS) {
			let lang = LANGS[l];
			if ('string' === typeof lang) {
				langs[l] = lang;
			} else {
				langs[l] = international ? lang.intl : lang.name;
			}
		}
		return langs;
	},

	scrollToElement: (element) => {
		$('html, body').animate({
			scrollTop: $(element).offset().top - 20
		}, 400);
	},

	isMobile: () => {
		let width = utils.toNumber((window.document?.documentElement?.clientWidth) || 1200);
		return (998 > width);
	},

	getMIME : ( ext ) => {
		let extName = utils.cleanString(ext);
		let validMIMES = {
		'7z' : 'application/x-7z-compressed',
        'aac' : 'audio/x-aac',
        'ai' : 'application/postscript',
        'aif' : 'audio/x-aiff',
        'asc' : 'text/plain',
        'asf' : 'video/x-ms-asf',
        'atom' : 'application/atom+xml',
        'avi' : 'video/x-msvideo',
        'bmp' : 'image/bmp',
        'bz2' : 'application/x-bzip2',
        'cer' : 'application/pkix-cert',
        'crl' : 'application/pkix-crl',
        'crt' : 'application/x-x509-ca-cert',
        'css' : 'text/css',
        'csv' : 'text/csv',
        'cu' : 'application/cu-seeme',
        'deb' : 'application/x-debian-package',
        'doc' : 'application/msword',
        'docx' : 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'dvi' : 'application/x-dvi',
        'eot' : 'application/vnd.ms-fontobject',
        'eps' : 'application/postscript',
        'epub' : 'application/epub+zip',
        'etx' : 'text/x-setext',
        'flac' : 'audio/flac',
        'flv' : 'video/x-flv',
        'gif' : 'image/gif',
        'gz' : 'application/gzip',
        'htm' : 'text/html',
        'html' : 'text/html',
        'ico' : 'image/x-icon',
        'ics' : 'text/calendar',
        'ini' : 'text/plain',
        'iso' : 'application/x-iso9660-image',
        'jar' : 'application/java-archive',
        'jpe' : 'image/jpeg',
        'jpeg' : 'image/jpeg',
        'jpg' : 'image/jpeg',
        'js' : 'text/javascript',
        'json' : 'application/json',
        'latex' : 'application/x-latex',
        'log' : 'text/plain',
        'm4a' : 'audio/mp4',
        'm4v' : 'video/mp4',
        'mid' : 'audio/midi',
        'midi' : 'audio/midi',
        'mov' : 'video/quicktime',
        'mp3' : 'audio/mpeg',
        'mp4' : 'video/mp4',
        'mp4a' : 'audio/mp4',
        'mp4v' : 'video/mp4',
        'mpe' : 'video/mpeg',
        'mpeg' : 'video/mpeg',
        'mpg' : 'video/mpeg',
        'mpg4' : 'video/mp4',
        'oga' : 'audio/ogg',
        'ogg' : 'audio/ogg',
        'ogv' : 'video/ogg',
        'ogx' : 'application/ogg',
        'pbm' : 'image/x-portable-bitmap',
        'pdf' : 'application/pdf',
        'pgm' : 'image/x-portable-graymap',
        'png' : 'image/png',
        'pnm' : 'image/x-portable-anymap',
        'ppm' : 'image/x-portable-pixmap',
        'ppt' : 'application/vnd.ms-powerpoint',
		'ppsx' : 'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
        'pptx' : 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'ps' : 'application/postscript',
        'qt' : 'video/quicktime',
        'rar' : 'application/x-rar-compressed',
        'ras' : 'image/x-cmu-raster',
        'rss' : 'application/rss+xml',
        'rtf' : 'application/rtf',
        'sgm' : 'text/sgml',
        'sgml' : 'text/sgml',
        'svg' : 'image/svg+xml',
        'swf' : 'application/x-shockwave-flash',
        'tar' : 'application/x-tar',
        'tif' : 'image/tiff',
        'tiff' : 'image/tiff',
        'torrent' : 'application/x-bittorrent',
        'ttf' : 'application/x-font-ttf',
        'txt' : 'text/plain',
        'wav' : 'audio/x-wav',
        'webm' : 'video/webm',
        'wma' : 'audio/x-ms-wma',
        'wmv' : 'video/x-ms-wmv',
        'woff' : 'application/x-font-woff',
        'wsdl' : 'application/wsdl+xml',
        'xbm' : 'image/x-xbitmap',
        'xls' : 'application/vnd.ms-excel',
        'xlsx' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'xml' : 'application/xml',
        'xpm' : 'image/x-xpixmap',
        'xwd' : 'image/x-xwindowdump',
        'yaml' : 'text/yaml',
        'yml' : 'text/yaml',
        'zip' : 'application/zip',
		}
		if ( validMIMES[extName] ) {
			return validMIMES[extName]
		}
		return extName;
	},
	downloadFile( url ){
		fetch(url)
		.then((response) => response.blob())
		.then((blob) => {
			const blobURL = window.URL.createObjectURL(new Blob([blob]));
			const fileName = url.split("/").pop();
			const aTag = document.createElement("a");
			aTag.href = blobURL;
			aTag.setAttribute("download", fileName);
			document.body.appendChild(aTag);
			aTag.click();
			aTag.remove();
		});
	}
};

export default utils;
